



/*
  Collection grid switch: 3 or 4 products per row on desktop (1 or 2 on mobile).
  Keeps the original function names, so the existing onclick="fourToThreeGrid()" /
  onclick="threeToFourGrid()" buttons keep working.
*/
(function () {
  if (window.__collectionGridSwitch) return;
  window.__collectionGridSwitch = true;

  var LAYOUTS = {
    3: {
      medium: 'medium-up--one-third',
      small: 'small--one-whole',
      aos: 'row-of-3',
      wrapper: 'three-in-row',
      buttons: ['gridButton-ftt', 'gridButton-tto']
    },
    4: {
      medium: 'medium-up--one-quarter',
      small: 'small--one-half',
      aos: 'row-of-4',
      wrapper: 'four-in-row',
      buttons: ['gridButton-ttf', 'gridButton-ott']
    }
  };

  // The layout the shopper picked; null until they click a grid button.
  var currentColumns = null;

  function setGridColumns(columns) {
    var layout = LAYOUTS[columns];
    var other = LAYOUTS[columns === 3 ? 4 : 3];
    if (!layout) return;
    currentColumns = columns;

    // Set the chosen classes (instead of toggling), so clicking twice or
    // newly loaded products can never end up in the opposite layout.
    document.querySelectorAll('.grid-product').forEach(function (item) {
      var changed = false;

      if (item.classList.contains(other.medium)) {
        item.classList.replace(other.medium, layout.medium);
        changed = true;
      }

      // Promo blocks keep the mobile width the theme gave them.
      if (!item.classList.contains('grid-promo-block') && item.classList.contains(other.small)) {
        item.classList.replace(other.small, layout.small);
        changed = true;
      }

      if (changed) {
        item.setAttribute('data-aos', layout.aos);
        // Not every grid item has an <image-element> (promo blocks, some slider markup),
        // so update whatever is there rather than assuming one exists.
        item.querySelectorAll('image-element').forEach(function (image) {
          image.classList.add('aos-animate');
        });
      }
    });

    // Some buttons only exist on desktop or mobile, so skip any that aren't on the page.
    layout.buttons.forEach(function (id) {
      var button = document.getElementById(id);
      if (button) button.classList.add('gridButton--active');
    });
    other.buttons.forEach(function (id) {
      var button = document.getElementById(id);
      if (button) button.classList.remove('gridButton--active');
    });

    document.querySelectorAll('.gridswitch_wrapper').forEach(function (wrapper) {
      wrapper.classList.add(layout.wrapper);
      wrapper.classList.remove(other.wrapper);
    });

    if (typeof updateFlickityGrid === 'function') updateFlickityGrid();
  }

  window.fourToThreeGrid = function () { setGridColumns(3); };
  window.threeToFourGrid = function () { setGridColumns(4); };

  // Infinite scroll (Ajaxinate) and filtering add products with the theme's default classes,
  // so re-apply the shopper's chosen layout whenever new products appear.
  function watchForNewProducts() {
    var scheduled = false;
    new MutationObserver(function (mutations) {
      if (!currentColumns || scheduled) return;
      var addedProducts = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches('.grid-product') || node.querySelector('.grid-product'));
        });
      });
      if (!addedProducts) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        setGridColumns(currentColumns);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) watchForNewProducts();
  else document.addEventListener('DOMContentLoaded', watchForNewProducts);
})();



// Float Label Handling
const FloatLabel = (() => {
  const handleFocus = (e) => {
    const target = e.target;
    target.parentNode.classList.add('active-field');
  };

  const handleBlur = (e) => {
    const target = e.target;
    if (!target.value) {
      target.parentNode.classList.remove('active-field');
    }
  };

  const bindEvents = (element) => {
    const floatField = element.querySelector('input, textarea');
    floatField.addEventListener('focus', handleFocus);
    floatField.addEventListener('blur', handleBlur);
  };

  const init = () => {
    const floatContainers = Array.from(document.querySelectorAll('.form-input-container'));

    floatContainers.forEach((element) => {
      const inputField = element.querySelector('input, textarea');
      if (inputField.value || inputField.hasAttribute('autofocus')) {
        element.classList.add('active-field');
      }
      bindEvents(element);
    });
  };

  return {
    init: init,
  };
})();
FloatLabel.init();

// Auto Resize Textareas
var textarea = document.querySelectorAll(".autoresizing");
textarea.forEach(element => {
  element.addEventListener('input', autoResize, false);
});
function autoResize() {
  this.style.height = 'auto';
  this.style.height = this.scrollHeight + 'px';
}

// Flickity Resize Helpers
function refreshFlickityHeight() {
  const flickityContainers = document.querySelectorAll('.product_image_slider');
  flickityContainers.forEach(slider => {
    const flkty = Flickity.data(slider);
    if (flkty) {
      flkty.resize();
    }
  });
}

function updateSlideHeights() {
  const slides = document.querySelectorAll('.image-wrap_slide');

  slides.forEach(slide => {
    const img = slide.querySelector('img');
    if (!img) return;

    const adjust = () => {
      const aspectRatio = img.naturalWidth / img.naturalHeight;
      const width = slide.offsetWidth;
      const newHeight = width / aspectRatio;
      slide.style.height = `${newHeight}px`;
    };

    if (img.complete && img.naturalHeight > 0) {
      adjust();
    } else {
      img.addEventListener('load', adjust);
    }
  });
}

function updateFlickityGrid() {
  updateSlideHeights();
  refreshFlickityHeight();
  setTimeout(refreshFlickityHeight, 300); // for good measure if lazy-loaded
}





var metaContentElement = document.querySelector('.meta_content');

document.addEventListener('variant:change', function (evt) {
  currentVariant = evt.detail.variant;
  shippingTime = variantMF[currentVariant.id][1]

  if (metaContentElement) {
    metaContentElement.textContent = shippingTime;
  }
  if (currentVariant.available) {
    metaContentElement.parentElement.classList.remove("hide")
  }
  else {
    metaContentElement.parentElement.classList.add("hide")
  }

});

document.addEventListener('DOMContentLoaded', function () {
  console.log(metaContentElement)
  if (metaContentElement) {
    metaContentElement.textContent = shippingTime;
  }
});